import { Link } from 'react-router-dom';
import { Clock, Leaf, Star } from 'lucide-react';

export function RecipeCard({ recipe, eager = false }) {
  return (
    <article className="group flex h-full flex-col border border-brand-gold/30 bg-brand-beige" data-testid={`recipe-card-${recipe.slug}`}>
      <Link to={`/rezepte/${recipe.slug}`} className="block overflow-hidden rounded-sm" tabIndex={-1} aria-hidden="true">
        <img
          src={recipe.image.src}
          srcSet={recipe.image.srcSet}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          width={recipe.image.width}
          height={recipe.image.height}
          alt=""
          loading={eager ? 'eager' : 'lazy'}
          className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
        />
      </Link>
      <div className="flex flex-1 flex-col p-6">
        <p className="eyebrow">{recipe.kategorie}</p>
        <h3 className="mt-2 font-serif text-2xl font-bold leading-tight sm:text-3xl">
          <Link to={`/rezepte/${recipe.slug}`} className="rounded-sm transition-colors duration-200 hover:text-brand-olive" data-testid={`recipe-link-${recipe.slug}`}>
            {recipe.name}
          </Link>
        </h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-brown-soft">{recipe.kurzbeschreibung}</p>
        <ul className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-brand-gold/30 pt-4 text-sm font-semibold text-brand-brown">
          {recipe.glutenfrei && (
            <li className="inline-flex items-center gap-1.5">
              <Leaf className="h-4 w-4 text-brand-olive" aria-hidden="true" /> glutenfrei
            </li>
          )}
          <li className="inline-flex items-center gap-1.5">
            <Clock className="h-4 w-4 text-brand-olive" aria-hidden="true" /> {recipe.gesamtzeit}
          </li>
          <li className="inline-flex items-center gap-1.5">
            <Star className="h-4 w-4 text-brand-gold" aria-hidden="true" /> von Felix probiert
          </li>
        </ul>
      </div>
    </article>
  );
}
